export default function(data) {
var __t, __p = '';
__p += '<div class="row-flex empty-saves">\n  <span class="icon bookmark"></span>\n  <div class="empty-saves-description">\n    <h3>You don\'t have any saved items yet.</h3>\n    <p>Saving is easy, just click on the bookmark icon within a deal or coupon module.  The deals and coupons you have collected will appear here.</p>\n  </div>\n</div>\n';
return __p
}